import {get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";


const bucketClubLn = window.config.Statics.BucketClubLnUrl.replace("dp-", "");
const urlPromoClubLn = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiPromoClubLnUrl;

const renderPromoClubLnEnHome = (data) => {
    const container = document.getElementById("promoClubLnEnHome");
    if (container) {
        const notas = data;

        if (notas == null)
            return;

        const cantidadNotas = notas.length;
        if (cantidadNotas == 0)
            return;

        let indexRandom1 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        let indexRandom2 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        let exitwhile = 0;
        while (indexRandom1 == indexRandom2 && exitwhile < 300) {
            indexRandom2 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        }

        let notaGrande = notas[indexRandom1];
        let notaChica = notas[indexRandom2];

        let promoPromoClubLnHtml = `<div class="techo-2 floatFix">
                                        <a href="https://club.lanacion.com.ar" target="_blank">Club <b>La Nación</b></a>
                                    </div>
                                    <article class="destacada foto floatFix">`;

        const benefitGrande = notaGrande.benefits[0];
        const benefitChica = notaChica.benefits[0];

   

        let imageHTML = "";
        let imageUrl = "";
        let imageUrlChica = "";
        
        if (notaGrande.imagenDestacar !== null && notaGrande.imagenDestacar !== 0) {
            var  objDestacado = notaGrande.images.find(img => img.id == notaGrande.imagenDestacar);
            if(objDestacado != undefined){
                imageUrl = BucketTools.urlBucketClubLn(bucketClubLn, objDestacado.id, "220", "", objDestacado.extension);
            }
        }
    

        if (imageUrl == "" && benefitGrande.images != null && benefitGrande.images.length > 0) {
            imageUrl = BucketTools.urlBucketClubLn(bucketClubLn, benefitGrande.images[0].id, "220", "", benefitGrande.images[0].extension);
        }

        imageHTML = `<a href="${notaGrande.link}" target="_blank"><img src="${imageUrl}" alt="${benefitGrande.description}" /></a><span></span><div>`;

        promoPromoClubLnHtml += imageHTML;

        promoPromoClubLnHtml += `<label><a href="${notaGrande.link}" target="_blank">${benefitGrande.benefitTypeName}</a></label>
                                        <p><a href="${notaGrande.link}" target="_blank">${notaGrande.name}</a></p>
                                    </div>
                                </article>`;
        //Chica
        promoPromoClubLnHtml += `<article class="noticia foto floatFix">`;

        if (notaChica.imagenDestacar !== null && notaChica.imagenDestacar !== 0) {
            var  objDestacadoChica = notaChica.images.find(img => img.id == notaChica.imagenDestacar);
            if(objDestacadoChica != undefined){
                imageUrlChica = BucketTools.urlBucketClubLn(bucketClubLn, objDestacadoChica.id, "80", "", objDestacadoChica.extension);
            }
        }



        if (imageUrlChica == "" && benefitChica.images != null && benefitChica.images.length > 0) {
            imageUrlChica = BucketTools.urlBucketClubLn(bucketClubLn, benefitChica.images[0].id, "80", "", benefitChica.images[0].extension);
        }

        promoPromoClubLnHtml += `<a href="${notaChica.link}" target="_blank"><img src="${imageUrlChica}" alt="${benefitChica.description}" /></a>
                                    <div>
                                        <label><a href="${notaChica.link}" target="_blank">${benefitChica.benefitTypeName}</a></label>
                                        <p><a href="${notaChica.link}" target="_blank">${notaChica.name}</a></p>
                                    </div>
                                    <div class="links">
                                        <a href="http://especiales.lanacion.com.ar/experiencias/newsletter/newsletter-online-combo2.html?cv=671&fc=568&utm_source=sitio_ln&utm_medium=Autopromo&utm_campaign=boton_caja_dinamica_sitio_ln" target="_blank">Pedí tu tarjeta </a> | <a href="https://www.lanacion.com.ar/club-la-nacion-t48832" target="_blank"> Propuestas Club LA NACION</a>
                                    </div>
                                </article>`;

        container.innerHTML = promoPromoClubLnHtml;

    }

}

export const getPromoClubLnEnHome = () => {
    if (document.getElementById("promoClubLnEnHome")) {
        get(urlPromoClubLn)
            .then(rs => JSON.parse(rs))
            .then(renderPromoClubLnEnHome);
    }

}


// WEBPACK FOOTER //
// ./Statics/scripts/home/beneficioClubLn.js